import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
  icon: ({ size, fill }) => ({
    width: `${size || "15"}px`,
    height: `${size || "15"}px`,
    fill: fill || "none",
  }),
});
